import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "row align-items-center" };
const _hoisted_2 = { class: "col-xl-4 col-lg-5 col-md-6" };
const _hoisted_3 = { class: "header-left-side justify-content-center justify-content-md-start d-flex align-items-center" };
const _hoisted_4 = { class: "col-xl-8 col-lg-7 col-md-6" };
const _hoisted_5 = { class: "header-right-side d-flex align-items-center justify-content-center justify-content-md-end" };
const _hoisted_6 = ["title"];
const _hoisted_7 = { class: "d-none d-xl-inline" };
const _hoisted_8 = { class: "dropdown profile-dropdown" };
const _hoisted_9 = {
    class: "dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
    type: "button",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = { class: "title d-none d-lg-block ms-10 ms-lg-15" };
const _hoisted_12 = { class: "d-block fw-bold mb-5 mb-md-8" };
const _hoisted_13 = { class: "text-body-emphasis fw-semibold fs-13" };
const _hoisted_14 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" };
const _hoisted_15 = { class: "ps-0 mb-0 list-unstyled dropdown-body" };
const _hoisted_16 = { class: "text-body-secondary fw-semibold transition position-relative cursor-pointer" };
const _hoisted_17 = { class: "text-body-secondary fw-semibold transition position-relative cursor-pointer" };
const _hoisted_18 = { class: "text-body-secondary fw-semibold transition position-relative" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LanguageSelector = _resolveComponent("LanguageSelector");
    return (_openBlock(), _createElementBlock("header", {
        class: _normalizeClass([
            'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed',
            { sticky: _ctx.isSticky },
        ]),
        id: "header"
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                        class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
                        id: "header-burger-menu",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
                    }, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("i", { class: "flaticon-menu-3" }, null, -1)
                        ]))]),
                    _cache[6] || (_cache[6] = _createElementVNode("form", { class: "search-box" }, [
                        _createElementVNode("div", { class: "input-group" })
                    ], -1))
                ])
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_LanguageSelector),
                    (_ctx.userRole === _ctx.UserRole.ADMIN || _ctx.userRole === _ctx.UserRole.FRANCHISE || _ctx.userRole === _ctx.UserRole.RESTAURANT)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn-closure-header ms-2 me-3 transition",
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.stateStoreInstance.toggleClosureModal(true))),
                            title: _ctx.$t('pos.dailyClosure')
                        }, [
                            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "ph-bold ph-folder-lock me-1" }, null, -1)),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('pos.closeDay') || 'Clôturer la journée'), 1)
                        ], 8, _hoisted_6))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", _hoisted_9, [
                            _createElementVNode("img", {
                                src: _ctx.userProfileIMG,
                                class: "rounded",
                                width: "30",
                                height: "30",
                                alt: "admin"
                            }, null, 8, _hoisted_10),
                            _createElementVNode("span", _hoisted_11, [
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.userLastName) + " " + _toDisplayString(_ctx.userFirstName), 1),
                                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getRoleName(_ctx.userRole ?? '')), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("ul", _hoisted_15, [
                                _createElementVNode("li", _hoisted_16, [
                                    _cache[8] || (_cache[8] = _createElementVNode("i", { class: "flaticon-user-2" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('header.profile')) + " ", 1),
                                    _createElementVNode("a", {
                                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.gotoUserDetail(_ctx.ActionCrud.EDIT))),
                                        class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                                    })
                                ]),
                                _createElementVNode("li", _hoisted_17, [
                                    _cache[9] || (_cache[9] = _createElementVNode("i", { class: "flaticon-user-2" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('header.changePassword')) + " ", 1),
                                    _createElementVNode("a", {
                                        onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.gotoUserDetail('password'))),
                                        class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                                    })
                                ]),
                                _createElementVNode("li", _hoisted_18, [
                                    _cache[10] || (_cache[10] = _createElementVNode("i", { class: "flaticon-logout" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('header.logout')) + " ", 1),
                                    _createElementVNode("a", {
                                        onClick: _cache[4] || (_cache[4] =
                                            //@ts-ignore
                                            (...args) => (_ctx.logout && _ctx.logout(...args))),
                                        class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                                    })
                                ])
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ], 2));
}
